import './stats-leaders/reducer/types';

/**
 * @typedef {object} StatsProState
 * @property {StatsLeadersState} statsLeaders
 * @property {object} glossary
 */

/**
 * @typedef {'seasons'|'rounds'} StatsLeadersStatsType
 */